/**
 * The control-class vocabulary the product_class enum carries, in display
 * order. It is the same three terms Treatment Method is derived from, shared
 * by the district product table and detail so both read one list.
 */
export const CONTROL_CLASS_LABELS: Record<string, string> = {
	chemical: "Chemical",
	biological: "Biological",
	physical: "Physical",
};

export const CONTROL_CLASS_OPTIONS = Object.entries(CONTROL_CLASS_LABELS).map(
	([value, label]) => ({ value, label }),
);
